import * as yup from 'yup';

function priceRangeTest(
  this: yup.TestContext,
  _value: string | undefined,
): boolean {
  const { priceMin, priceMax } = this.parent;

  if (!priceMin || !priceMax) {
    return true;
  }

  const min = Number(priceMin);
  const max = Number(priceMax);

  if (isNaN(min) || isNaN(max)) {
    return true;
  }

  return min <= max;
}

export const esiFeeScheduleFilterSchema = yup.object({
  programs: yup.array().of(yup.string().defined()).defined(),
  paymentTypes: yup.array().of(yup.string().defined()).defined(),
  priceMin: yup
    .string()
    .defined()
    .test('price-range', 'Min > Max', priceRangeTest),
  priceMax: yup
    .string()
    .defined()
    .test('price-range', 'Min > Max', priceRangeTest),
  upc: yup.string().defined(),
});
